import { render, staticRenderFns } from "./topup-manual-modal.vue?vue&type=template&id=04004982&"
import script from "./topup-manual-modal.vue?vue&type=script&lang=js&"
export * from "./topup-manual-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports